import React from 'react'
import './ContestIndex.css';
import ContestIndex01 from "../../../static/img/Contest/crownWhite.svg";
import ContestIndex02 from "../../../static/img/Contest/cupWhite.svg";
import ContestIndex03 from "../../../static/img/Contest/medaWhite.svg";
import ContestMenu from "./ContestMenu";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";

function ContestIndexSource(props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['','ElementMenuActive','','','','']} Active={1}>
            <main className="ContestIndex">
                <div className="ContestIndexTitle"><TextSource ArrIndex= 'ContestIndex0015'>Contests</TextSource> </div>
                <div className="ContestIndexGrid">
                    <div className="ContestIndexGridMain">
                        <ChangeLink lang={props.lang} to='/contests/join/championship'>
                            <div className="ContestIndexGridMainElement ContestIndexGridMainElement01">
                                <div className="ContestIndexGridMainElementIn">
                                    <img src={ContestIndex01}  alt='Ifyoudontseeimages' width='52px'/>
                                    <div className="ContestIndexGridMainElementText"><TextSource ArrIndex= 'ContestIndex0020'>Newbie Championship</TextSource>  </div>
                                </div>
                            </div>
                        </ChangeLink>
                        <ChangeLink lang={props.lang} to='/contests/all-history'>
                            <div className="ContestIndexGridMainElement ContestIndexGridMainElement02">
                                <div className="ContestIndexGridMainElementIn">
                                    <img src={ContestIndex02}  alt='Ifyoudontseeimages' width='52px'/>
                                    <div className="ContestIndexGridMainElementText"><TextSource ArrIndex= 'ContestIndex0025'>Old Contests</TextSource>  </div>
                                </div>
                            </div>
                        </ChangeLink>
                        <ChangeLink lang={props.lang} to='/contests/prize'>
                            <div className="ContestIndexGridMainElement ContestIndexGridMainElement03">
                                <div className="ContestIndexGridMainElementIn">
                                    <img src={ContestIndex03}  alt='Ifyoudontseeimages' width='52px'/>
                                    <div className="ContestIndexGridMainElementText"><TextSource ArrIndex= 'ContestIndex0030'>Get the Prize</TextSource>  </div>
                                </div>
                            </div>
                        </ChangeLink>
                    </div>
                    <ContestMenu lang={props.lang} data={props.data} MenuElements={['ActiveElements','NoActiveElements','NoActiveElements']}/>
                </div>
            </main>
        </LayoutMain>
    )}
export default ContestIndexSource




